import { restApi } from '../../api';
import { BrandUser, BrandUserRoleOptionDTO, UpdateBrandUserRoleInput } from './brandUsers.types';

const PATH = 'brands/users';

export const findBrandUserByContextId = (contextId: string) =>
  restApi.get<BrandUser>(`${PATH}/${contextId}`);

export const findBrandUserRoleOptions = () =>
  restApi.get<BrandUserRoleOptionDTO[]>(`${PATH}/role-options`);

export const updateBrandUserRole = ({ contextId, roleId }: UpdateBrandUserRoleInput) =>
  restApi.patch<BrandUser>(`${PATH}/${contextId}/role`, { roleId });
